import Vue from "vue"

const state = {
  token: localStorage.getItem("userToken") || "",
  status: "",
  hasLoadedOnce: false,
  profile: {},
}

const getters = {
  isAuthenticated: (state) => !!state.token,
  authStatus: (state) => state.status,
  getProfile: (state) => state.profile,
  isProfileLoaded: (state) => !!state.profile.email,
}

const actions = {
  login: ({ commit, dispatch }, user) => {
    return new Promise((resolve, reject) => {
      commit("AUTH_LOGIN")
      Vue.axios
        .post("/auth/login/", user)
        .then((resp) => {
          localStorage.setItem("userToken", resp.data.key)
          Vue.axios.defaults.headers.common.Authorization = `Token ${resp.data.key}`
          commit("AUTH_SUCCESS", resp.data)
          dispatch("getUser")
          resolve(resp.data)
        })
        .catch((err) => {
          commit("AUTH_ERROR", err)
          localStorage.removeItem("userToken")
          reject(err)
        })
    })
  },
  logout: ({ commit }) => {
    return new Promise((resolve) => {
      commit("AUTH_LOGOUT")
      localStorage.removeItem("userToken")
      resolve()
    })
  },
  resetPassword: (_, user) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post("/auth/password/reset/", user)
        .then((resp) => {
          resolve(resp.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  resetPasswordConfirm: (_, user) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post("/auth/password/reset/confirm/", user)
        .then((resp) => {
          resolve(resp.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  createUser: (_, personId) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(`/people/${personId}/create_user/`)
        .then((resp) => {
          resolve(resp.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  // eslint-disable-next-line no-unused-vars
  getUser: ({ commit, dispatch }) => {
    Vue.axios
      .get("/auth/user/")
      .then((resp) => {
        commit("USER_SUCCESS", resp.data)
      })
      .catch(() => {
        commit("AUTH_ERROR")
        // if resp is unauthorized, logout, too
        dispatch("logout")
      })
  },
}

const mutations = {
  AUTH_LOGIN: (state) => {
    state.status = "loading"
  },
  AUTH_SUCCESS: (state, resp) => {
    state.status = "success"
    state.token = resp.key
    state.hasLoadedOnce = true
  },
  AUTH_ERROR: (state) => {
    state.status = "error"
    state.hasLoadedOnce = true
  },
  AUTH_LOGOUT: (state) => {
    state.token = ""
    state.profile = {}
  },
  USER_SUCCESS: (state, resp) => {
    state.status = "success"
    Vue.set(state, "profile", resp)
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
